// extracted by mini-css-extract-plugin
export default {"root":"TransitionHeader-root","verticalLine":"TransitionHeader-verticalLine","spacing":"TransitionHeader-spacing","header":"TransitionHeader-header"};